import type { ConfigProvider } from '../config-provider';
import { defaultConfig } from '../default-config';

function parseAsDefault<T>(value: string, defaultValue: T): T {
    if (typeof defaultValue === 'number') {
        return Number(value) as T;
    }
    if (typeof defaultValue === 'boolean') {
        return (value === 'true') as T;
    }
    return value as T;
}

export const localStorageConfigProvider: ConfigProvider = (key) => {
    if (import.meta.env.VITE_APP_ENV !== 'sandbox' && import.meta.env.VITE_APP_ENV !== 'local') {
        return undefined;
    }

    const value = localStorage?.getItem(key);
    if (value) {
        const parsedValue = parseAsDefault(value, defaultConfig[key]);
        if (!isNaN(parsedValue) && isFinite(parsedValue)) {
            return parsedValue;
        }
    }

    return undefined;
};
